export default "__VITE_ASSET__BdBen5Xt__"